import { Card } from '@blueprintjs/core';
import AppContentView from 'Components/Generic/AppContentView';
import BOSIcon from 'Components/Generic/Misc/BOSIcon';

const Dashboard = () => {
  let dashboardContent = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Card>
        <div style={{ display: 'flex', gap: 12 }}>
          <BOSIcon large icon={'build'} title={'Under Construction'} />
          <BOSIcon large icon={'build'} />
        </div>
      </Card>
      <Card>
        <BOSIcon icon={'lightbulb'} title={'Widget Ideas:'} />
        <div
          style={{
            paddingTop: 16,
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
          }}>
          <BOSIcon small icon={'pin'} title={'News items'} />
          <BOSIcon small icon={'help'} title={'Help'} />
          <BOSIcon
            small
            icon={'code-block'}
            title={'Quick link to orders to be picked up'}
          />
          <BOSIcon
            small
            icon={'code-block'}
            title={"Quick link to transactions that are pending and 'mine'"}
          />
          <BOSIcon
            small
            icon={'code-block'}
            title={
              "List of notes on requests that I'm the buyer or requester for"
            }
          />
          <BOSIcon
            small
            icon={'code-block'}
            title={"Quick link to 'my orders'"}
          />
          <BOSIcon
            small
            icon={'code-block'}
            title={'For approvers: orders needing my approval'}
          />
        </div>
      </Card>
    </div>
  );

  return (
    <AppContentView hideBreadcrumbs title=''>
      {dashboardContent}
    </AppContentView>
  );
};

export default Dashboard;
